import { gql } from '@apollo/client';

export const GET_CASH_FLOWS = gql`
    query venueShifts($offset: Int, $limit: Int, $dateFromTo: DateFromTo){
        venueShifts(offset: $offset, limit: $limit, dateFromTo: $dateFromTo) {
            id
            startedUtc
            finishedUtc
            initialCashAmount
            expectedCashAmount
            finalCashAmount
            expectedCreditCardAmount
            finalCreditCardAmount
            cashIncome
            cashDrawerOperations {
                id
                amount
                createdUtc
                note
                createdBy {
                    account {
                        firstName
                        lastName
                    }
                }
            }
            startedBy {
                account {
                    firstName
                    lastName
                }
            }
            finishedBy {
                account {
                    firstName
                    lastName
                }
            }
        }
    }
`;

export const GET_CASH_DRAWER_REPORT = gql`
    query GetCashDrawerReport($dateFromTo: DateFromTo) {
        cashDrawerReport(dateFromTo: $dateFromTo)
    }
`;
